import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { SubtypeDPFilters } from './filters';
import { SubtypeDPList } from './list';
import { SUBTYPE_DP, SUBTYPE_DP_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const SubtypeDP = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de Subtipo DP"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBTYPE_DP_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBTYPE_DP,
                        }}
                    />
                }
            >
                <SubtypeDPFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <SubtypeDPList filters={filters} />
        </>
    );
};
